module.exports = __webpack_public_path__ + "img/respiratory-diseases-platform.d0780563.png";